module.exports = "<div ui-view class=\"subview fade-in-up\" ctrl-admin=\"$ctrl\" style=\"padding: 0;\"></div>\n\n<!-- ALERTA POR FALTA DE CONEXIÓN -->\n<img ng-show=\"$ctrl.sinConexion\" src=\"/assets/img/disconnected.png\" class=\"img-alert-conection  ng-hide\" />\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/layout/sidebar/sidebar.html
// module id = 409
// module chunks = 0